<template>
  <div class="edit-container">
    <div
      v-if="!isNewSME"
      class="abs-top-right">
      <v-button
        size="small"
        @click="cancelClick">Cancel
      </v-button>
      <div
        v-show="step === 0&&productId!=22"
        class="">
        <v-button
          @click="handlerLessSave(2)">Create Refer Case
        </v-button>
      </div>
      <div
        v-show="step === 0"
        class="">
        <v-button
          type="primary"
          @click="handlerLessSave(1)">Save
        </v-button>
      </div>
      <div v-show="step === 0">
        <v-button
          v-if="form.plan_id != null"
          type="primary"
          @click="handlerNext">Next
        </v-button>
      </div>
      <div v-show="step !== 0">
        <v-button @click="step = 0">Back</v-button>
        <v-button
          type="primary"
          :disabled="step == 2"
          @click="handlerSave">Save
        </v-button>
      </div>
    </div>
    <h1 v-if="!isNewSME">Edit Quote</h1>
    <section v-show="step === 0">
      <housemaid-policy-form
        v-if="productId == 12"
        ref="housemaid-policy-form"
        :form="formData"
        :check-refer="checkRefer"
        editQuote
        @getFormData="getHousemaidFormData"/>
      <working-policy-form
        v-else-if="productId == 13"
        ref="working-policy-form"
        :form="formData"
        :check-refer="2"
        editQuote
        @getFormData="getHousemaidFormData"/>
      <decoration-policy-form
        v-else-if="productId == 15"
        ref="decoration-policy-form"
        :form="formData"
        :check-refer="checkRefer"
        editQuote
        @getFormData="getHousemaidFormData"/>
      <student-policy-form
        v-else-if="productId == 16"
        ref="student-policy-form"
        :form="formData"
        :check-refer="2"
        editQuote
        :isBenefitCoverage="true"
        @getFormData="getHousemaidFormData"/>
      <div
        v-else-if="productId == 17"
        class="width-700">
        <homefire-policy-form
          ref="homefire-policy-form"
          :form="formData"
          :check-refer="checkRefer"
          editQuote
          :isBenefitCoverage="true"
          @getFormData="getHousemaidFormData"/>
      </div>
      <div
        v-else-if="productId == 18"
        class="width-700">
        <personal-policy-form
          ref="personal-policy-form"
          :form="formData"
          :check-refer="checkRefer"
          editQuote
          @getFormData="getHousemaidFormData"/>
      </div>
      <div
        v-else-if="productId == 14"
      >
        <travel-policy-form
          ref="travel-policy-form"
          :form="formData"
          :check-refer="2"
          editQuote
          @getFormData="getHousemaidFormData"/>
      </div>
      <div
        v-else-if="productId == 20"
        class="width-700">
        <fire-policy-form
          ref="fire-policy-form"
          :form="formData"
          :check-refer="checkRefer"
          editQuote
          @getFormData="getHousemaidFormData"/>
      </div>
      <div
        v-else-if="productId == 22"
        class="width-700">
        <pet-policy-form
          ref="pet-policy-form"
          :form="formData"
          :check-refer="checkRefer"
          editQuote
          @getFormData="getHousemaidFormData"/>
      </div>
      <div
        v-else-if="productId == 21"
        class="width-700">
        <drone-policy-form
          ref="drone-policy-form"
          :form="formData"
          :check-refer="checkRefer"
          editQuote
          @getFormData="getHousemaidFormData"/>
      </div>
      <div v-else-if="[80,81].includes(productId)">
        <div
          v-if="!isNewSME"
          class="width-700">
          <sme-form
            ref="sme-form"
            :form="formData"
            :check-refer="checkRefer"
            @getFormData="getHousemaidFormData"
          ></sme-form>
        </div>
        <div
          v-else
        >
          <edit-sme-kyc
            ref="sme-form"
            :form="formData"
            :remark="form.remark_list"
            :is-car="isCAR"
            is-quote
            :is-fina="form.merchant_platform==2"
            @refresh="handleFresh"
          ></edit-sme-kyc>
        </div>
      </div>
      <!-- motor -->
      <template v-else>
        <lazy-dom>
          <!--          <div class="form-item form-half">-->
          <!--            <span>Effective Date</span>-->
          <!--            <v-date-picker v-model="formData.pcy_cmnt_dt"/>-->
          <!--          </div>-->
          <div class="flex flex-align-center">
            <div class="form-half form-item">
              <span>Effective Date</span>
              <v-date-picker
                v-model="formData.pcy_cmnt_dt"
                :_45daysComfirm="true"
                @change="handlerChangePcyDt"/>

            </div>
            <span class="mg-l-15 mg-r-15 color-dark fs-14">Or</span>
            <v-checkbox
              v-model="formData.is_eff_dt_delay"
              :is-boolean="false"
              button-type>As Soon As Possible</v-checkbox>
          </div>
          <div class="form-item form-half">
            <span>Coverage</span>
            <v-radio-group
              v-model="formData.trm_of_cvr"
              disabled
              :button="true"
              :list="allCoverTypeOptions" />
          </div>
          <div
            v-if="formData.trm_of_cvr != 1"
            class="form-item form-half">
            <span>Vehicle Market Value (Sum Insured)</span>
            <!--            <el-form-item prop="isrd_vl">-->
            <v-input
              v-model="formData.isrd_vl"
              type="number"
              :min="0"
              append="HK$"/>
            <!--            </el-form-item>-->
          </div>
          <template v-if="formData.class_id !== 14&&!isMotorTrade">
            <div class="flex-sb">
              <div class="form-half">
                <div
                  v-if="formData.trm_of_cvr != 1"
                  class="form-item">
                  <span>Hire Purchase Owner</span>
                  <!--                <el-form-item prop="hp_ind">-->
                  <v-radio-group
                    v-model="formData.hp_ind"
                    :border="true"
                    :list="yesNoOptions" />
                <!--                </el-form-item>-->
                </div>
              </div>
              <!--              <div class="form-half">-->
              <!--                <div-->
              <!--                  v-if="formData.trm_of_cvr != 1 && formData.hp_ind == 1"-->
              <!--                  class="form-item">-->
              <!--                  <span>Name of Hire Purchase Owner (If Yes for Hire purchase)</span>-->
              <!--                  &lt;!&ndash;                <el-form-item prop="mortgagor">&ndash;&gt;-->
              <!--                  <v-select-->
              <!--                    v-model="formData.mortgagor"-->
              <!--                    :list="localAllOptions.mortgagor" />-->
              <!--                &lt;!&ndash;                </el-form-item>&ndash;&gt;-->
              <!--                </div>-->
              <!--              </div>-->
              <div
                v-if="formData.trm_of_cvr != 1 && formData.hp_ind == 1"
                class="form-item">
                <span>Name of Hire Purchase Owner (If Yes for Hire purchase)</span>
                <div
                  ref="mortgagor"
                  prop="mortgagor">
                  <v-select
                    v-model="formData.mortgagor"
                    :list="mortgagorOption" />
                </div>
                <div
                  v-if="isMortgagorOther"
                  ref="mortgagor_other"
                  class="margin-top-ten"
                  prop="mortgagor_other">
                  <v-input
                    v-model="formData.mortgagor_other"
                  />
                </div>
              </div>
            </div>
          </template>
          <div
            v-if="formData.class_id == 11&&!isFina"
            class="form-item form-half extra_checkbox">
            <span>Extra Benefits</span>
            <v-checkbox-group
              v-model="formData.extra_benefits"
              :button="true"
              :list="allOptions11.extra_benefits"
            />
          </div>
          <div
            v-if="allOptions11.benefits.length"
            class="form-item form-half extra_checkbox">
            <span>More Benefits</span>
            <v-checkbox-group
              v-model="formData.benefits"
              hasGroup
              :button="true"
              :list="allOptions11.benefits"
            />
          </div>
          <template v-if="isMotorTrade">
            <div class="form-item">
              <span>Type of insurance</span>
              <v-radio-group
                v-model="formData.type_of_ins"
                :button="true"
                disabled
                :list="allOptions13.type_of_ins" />
            </div>
            <div
              v-if="formData.type_of_ins == 2"
              class="form-item">
              <span>Number of Named Driver(s)</span>
              <v-radio-group
                v-model="formData.no_of_nm_drvr"
                :button="true"
                disabled
                :list="numberFourOptions"
              />
            </div>
            <div class="form-item">
              <span>No Claims in the past 3 years?</span>
              <v-radio-group
                v-model="formData.no_claim_3_year"
                :border="true"
                :list="yesNoOptions"
              />
            </div>
          </template>
          <h1>Policyholder Details</h1>
          <policy-holder
            ref="policy-holder"
            :formDataLock="formDataLock"
            :form="formData"
            :is-t-plate="isTPlate"
            @one-driver="(status) => policyOneDriver = status"
            @change-driver="handlerPolicyDriverInfo"
            @getFormData="getSubFormData"
            @confirm="handlerConfirmChangeInfo"/>
          <template v-if="!isMotorTrade">
            <h1>Insured Vehicle</h1>
            <insured-vehicle-form
              ref="insured-vehicle-form"
              :disabledList="['trm_of_cvr']"
              :formDataLock="formDataLock"
              :form="formData"
              :usageInd.sync="formData.usage_ind"
              @getFormData="getSubFormData"
              @handleInd="handleInd"
              @already-owned="handleOwned"
            />
          </template>
          <template v-if="!isMotorTrade||isMotorTrade&&!isTPlate">
            <h1>Named Driver Information</h1>
            <drivers-base-info-form
              ref="drivers-base-info-form"
              :formDataLock="formDataLock"
              :form="formData"
              :policyOneDriver="policyOneDriver"
              @getFormData="getSubFormData"
              @upload-file="uploadDriversFile"
              @change-policy-file="handlerDriverPolicyFile"
              @open-driver="handlerOpenDriver"
            />
          </template>
          <h1>Documents</h1>
          <document-form
            ref="document-form"
            :formDataLock="formDataLock"
            :inter="true"
            :form="formData"
            :currentDriversData="currentDriversData"
            @upload-file="handlerUploadCardFile"
            @delete-card-file="handlerDeleteCardFile" />
        </lazy-dom>
      </template>
      <lazy-dom notLoading>
        <use-personal-data
          v-if="!isNewSME"
          ref="use-personal-data"
          :marketing_data="formData.marketing_data"
          :company_name="formData.company_language"
          @sendData="getData"></use-personal-data>
      </lazy-dom>
    </section>
    <section v-show="step === 1">
      <div class="flex confirm-container">
        <div>
          <h1>Premium</h1>
          <div class="table">
            <div class="tr th">
              <span>Item</span>
              <span>Percentage</span>
              <span>Amount</span>
            </div>
            <div
              v-for="(item, index) in premiumData"
              :key="index"
              class="tr">
              <span>{{ item.item }}</span>
              <span>
                <template v-if="item.pct_n == item.pct_o">
                  <span>{{ item.pct_o }}</span>
                </template>
                <template v-else>
                  <span class="red text-line">{{ item.pct_o }}</span>
                  <span class="green">{{ item.pct_n }}</span>
                </template>
              </span>
              <span>
                <template v-if="item.amt_n == item.amt_o">
                  <span>{{ item.amt_o }}</span>
                </template>
                <template v-else>
                  <span class="red text-line">{{ item.amt_o }}</span>
                  <span class="green">{{ item.amt_n }}</span>
                </template>
              </span>
            </div>
          </div>
        </div>
        <div v-if="!isSMEProduct">
          <h1>Coverage</h1>
          <div class="table">
            <div
              v-for="(item, index) in coverageData"
              :key="index"
              class="tr">
              <span>{{ item.item }}</span>
              <span>
                <template v-if="item.amt_n == item.amt_o">
                  <span>{{ item.amt_o }}</span>
                </template>
                <template v-else>
                  <span class="red text-line">{{ item.amt_o }}</span>
                  <span class="green">{{ item.amt_n }}</span>
                </template>
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section v-show="step === 2">
      <h1>Select Plan</h1>
      <p>The new information does not fit inside the previously selected plan. Please manually enter quote or select
        another plan.</p>
      <div class="card">
        <div class="flex-sb">
          <span class="max-label">Convert Refer Case Support Ticket</span>
          <v-button
            type="primary"
            @click="referNext">Proceed to Create Ticket
          </v-button>
        </div>
      </div>
      <quote-plan-list
        v-if="allQuoteList && allQuoteList.length > 0"
        :allQuoteList="allQuoteList"
        :quoteDetailData="quoteDetailData"
        :classId="classId"
        @buy-policy="handlerBuyPolicy"/>
    </section>
  </div>
</template>

<script>
import InsuredVehicleForm from '@/views/components/insured-vehicle-form'
import PolicyHolder from '@/views/components/policy-holder-form'
import DriversBaseInfoForm from '@/views/components/drivers-base-info-form'
import DocumentForm from '@/views/tickets/components/document-form'
import QuotePlanList from '@/views/quoting/components/quote-plan-list'
import {editQuoteResult, saveQuotation} from '@/api/quote'
import {saveOrder,saveReferCaseOrder} from '@/api/order'
import MixinFormat from '@/mixins/format'
import HousemaidPolicyForm from '@/views/quoting/modules/housemaid/form/housemaid-policy-form'
import DecorationPolicyForm from '@/views/quoting/modules/decoration/form/decoration-policy-form'
import HomefirePolicyForm from '@/views/quoting/modules/homefire/form/homefire-policy-form'
import travelPolicyForm from '@/views/quoting/modules/travel/form/travel-policy-form'
import StudentPolicyForm from '@/views/quoting/modules/student/form/student-policy-form'
import PersonalPolicyForm from '@/views/quoting/modules/personal/form/personal-policy-form'
import WorkingPolicyForm from '@/views/quoting/modules/working/form/working-policy-form'
import firePolicyForm from '@/views/quoting/modules/homefire/form/fire-policy-form'
import dronePolicyForm from '@/views/quoting/modules/drone/from/policy-from'
import petPolicyForm from '@/views/quoting/modules/pet/form/pet-policy-form'
import {mapActions, mapState} from 'vuex'
import MixinOptions from '@/mixins/options'
import {addReferral} from '@api/refer'
import smeForm from '@/views/quoting/sme/component/sme-form'
import {editSMEQuoteResult, saveSMEKyc} from '@api/sme'
import {productAPiPath} from '@/utils/smePath'
import UsePersonalData from '@/views/components/use-personal-data'
import EditSmeKyc from '@/views/sme/components/edit-sme-kyc'

export default {
  name: 'DetailForm',
  components: {
    EditSmeKyc,
    InsuredVehicleForm,
    PolicyHolder,
    DriversBaseInfoForm,
    DocumentForm,
    QuotePlanList,
    HousemaidPolicyForm,
    DecorationPolicyForm,
    HomefirePolicyForm,
    StudentPolicyForm,
    travelPolicyForm,
    dronePolicyForm,
    WorkingPolicyForm,
    PersonalPolicyForm,
    firePolicyForm,
    smeForm,
    UsePersonalData,
    petPolicyForm
  },
  mixins: [MixinFormat,MixinOptions],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    editStatus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checkRefer:2,
      less:false,
      formDataLock: 0, // 表單鎖，防止外層修改數據覆蓋了組件裏的表單數據
      policyOneDriver: false, // 投保人關聯第一名記名司機
      step: 0, // 標記編輯步驟
      premiumData: [],
      coverageData: [],
      currentDriversData: [],
      subForm: {
        'insured-vehicle-form': false,
        'policy-holder': false,
        'drivers-base-info-form': false
      },
      formData: {
        updDefInfo: [],
        pcy_cmnt_dt: '',
        mortgagor_other:'',
        extra_benefits:[],
        benefits: [],
        already_owned_by_ind:'',
        usage_ind:1,
        type_of_ins:'',
        no_of_nm_drvr:'',
        no_claim_3_year:'',
      },
      formParams: {},
      allQuoteList: [],
      quoteDetailData: [],
      resultParams: {},
      type:1,
      personalData: {}
    }
  },
  computed: {
    ...mapState('quote',['isBack']),
    productId() {
      return this.form.product_id || 11
    },
    isCAR() {
      return this.classId==79
    },
    isFina() {
      return this.form.merchant_platform ==2
    },
    classId() {
      return this.formData.class_id || 14
    },
    smeType(){
      return productAPiPath[this.classId]
    },
    isSMEProduct(){
      return this.productId==80
    },
    orderId() {
      return this.formData.id||this.$route.query.order_id
    },
    localAllOptions() {
      if(this.classId === 14) {
        return this.allOptions
      } else {
        return this[`allOptions${this.classId}`]
      }
    },
    mortgagorOption() {
      // 拿status 為1的數據
      let { mortgagor=[] } = this.localAllOptions||{}
      if(mortgagor.length) {
        mortgagor = mortgagor.filter(e=>e.status)
      }
      return mortgagor
    },
    isMortgagorOther(){
      let {mortgagor}=this.formData
      let list = this.mortgagorOption.filter(item=>{
        return item.id==mortgagor
      })
      return list.length>0&&list[0].is_other==1?true:false
    },
    isNewSME(){
      let {sme_versions} = this.form||{}
      return sme_versions==3
    },
    is_refer_order(){
      let {is_refer_order} = this.form
      return is_refer_order == 1
    },
    isMotorTrade(){
      let {class_id} = this.form||{}
      return class_id ==13
    },
    isTPlate(){
      let {type_of_ins} = this.form||{}
      return type_of_ins ==1
    }
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        this.formDataLock += 1
        this.formData = Object.assign(this.formData, JSON.parse(JSON.stringify(val)))

        // 提取kyc_benefit赋值到benefits
        if(val && val.quote_coverage_list && val.quote_coverage_list.kyc_benefit){
          val.quote_coverage_list.kyc_benefit.forEach(item => {
            if(item.is_group){
              if(item.is_selected){
                this.formData.benefits.push(item.id)
              }
            }else{
              this.formData.benefits.push(item.id)
            }
          })
        }
      }
    },
    editStatus: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.formDataLock += 1
          let params = {
            pcy_cmnt_dt: ''
          }
          this.formData = Object.assign(this.formData, params, JSON.parse(JSON.stringify(this.form)))
        } else this.formData = {}
      }
    },
  },
  mounted() {
    // if (this.$route.query.isBack) {
    //   this.handlerNext()
    //   this.network().stepTypeIsBack()
    // }
  },
  methods: {
    // ...mapActions('quote', ['setQuoteInformationForm']),
    ...mapActions('quote',['setIsBack','setQuoteInformationForm']),
    ...mapActions('account', ['setCustomerId']),
    ...mapActions('smeQuote', ['setSMEQuoteInformationForm']),
    handlerChangePcyDt(){
      this.formData.is_eff_dt_delay = 0
    },
    handleFresh(){
      this.$emit('update')
    },
    handleInd(params){
      Object.assign(this.formData,params)
      let obj = JSON.parse(JSON.stringify(this.formData))
      this.formData = obj
    },
    handleOwned(params){
      this.formData.already_owned_by_ind = params
    },
    getHousemaidFormData(data) {
      const params = {
        ...data,
        order_id: this.orderId
      }
      this.resultParams = JSON.parse(JSON.stringify(params))
      this.formParams = JSON.parse(JSON.stringify(params))
      if(!this.less){
        this.network().editQuoteResult()
      }else{
        if(this.type==2){
          if(this.isSMEProduct){
            this.network().handlerSMECreateRefer()
          }else{
            this.handlerCreateRefer()
          }
        }else {
          if(this.isSMEProduct){
            this.network().saveSMEKycLess({less_verify_save:1})
          }else
            this.network().saveLessOrder()
        }
      }
    },
    //todo
    getSMEFormData(data){
      const params = {
        ...data,
        order_id: this.orderId
      }
      this.resultParams = JSON.parse(JSON.stringify(params))
      this.formParams = JSON.parse(JSON.stringify(params))
      if(!this.less)
        this.getSMEQuoteResult()
    },
    async getSMEQuoteResult(){
      let {data} = await saveSMEKyc({
        ...this.resultParams,
        order_id: this.orderId,
        less_verify_save:1,
      },this.classId)
      this.network().editSMEQuoteResult()
    },
    // 投保人資料關聯幾名司機
    handlerPolicyDriverInfo(data) {
      const id_type_pic = this.$refs['document-form'].getCardFileData()
      const result = {
        ...data,
        id_type_pic
      }
      this.$refs['drivers-base-info-form'].handlerPolicyDriverInfo(result)
    },
    getSubFormData(form, data) {
      this.subForm[form] = true
      this.formData = Object.assign(this.formData, data)
      // console.log(data, form)
    },
    handlerDriverPolicyFile(data) {
      this.$refs['document-form'].updatePolicyFile(data)
    },
    // 更新司機文件數據
    uploadDriversFile(data) {
      // const { index, type, name, id } = data
      this.$refs['document-form'].updateDriversFile(data)
    },
    handlerUploadCardFile(data) {
      if(this.policyOneDriver) {
        this.$refs['drivers-base-info-form'].updateOnePolicyFile(data)
      }
    },
    handlerDeleteCardFile() {
      if(this.policyOneDriver) {
        this.$refs['drivers-base-info-form'].deleteOnePolicyFile()
      }
    },
    async handlerNext(type) {
      this.less = false
      const productForm = {
        12: 'housemaid-policy-form',
        13: 'working-policy-form',
        14: 'travel-policy-form',
        15: 'decoration-policy-form',
        16: 'student-policy-form',
        17: 'homefire-policy-form',
        18: 'personal-policy-form',
        20: 'fire-policy-form',
        21: 'drone-policy-form',
        22: 'pet-policy-form',
      }
      if(this.isSMEProduct){
        this.$refs['sme-form'].submitForm()
        return
      }
      if (this.productId != 11) {
        this.$refs[productForm[this.productId]].submitForm()
        return
      }
      // motor
      const params = await this.handler().getFormDataResult()
      if (!params) return

      this.resultParams = params
      const { updDefInfo } = params

      if(updDefInfo && updDefInfo.length > 0&&!this.isFina) {
        // if (params.isUpdatePolicyData === 1) {
        this.$refs['policy-holder'].openConfirmDialog()
      } else {
        this.network().editQuoteResult()
      }
    },
    async handlerCreateRefer(params){
      const {data} = await saveOrder({
        ...this.formParams,
        less_verify_save:1,
        marketing_data: this.personalData
      })
      this.setQuoteInformationForm(this.formParams)
      this.$router.push({
        path: '/quoting/quote/refer/information',
        query: {
          order_id: this.$route.query.order_id,
          product_id: this.$route.query.product_id
        }
      })
    },
    async handlerCreateReferOrder(params){
      const {data} = await saveReferCaseOrder({
        ...this.formParams,
        less_verify_save:1,
        marketing_data: this.personalData
      })
      this.setQuoteInformationForm(this.formParams)
      this.$router.push({
        path: '/quoting/quote/refer/information',
        query: {
          order_id: this.$route.query.order_id,
          product_id: this.$route.query.product_id
        }
      })
    },
    getSave()
    {
      const productForm = {
        12: 'housemaid-policy-form',
        13: 'working-policy-form',
        14: 'travel-policy-form',
        15: 'decoration-policy-form',
        16: 'student-policy-form',
        17: 'homefire-policy-form',
        18: 'personal-policy-form',
        20: 'fire-policy-form',
        22: 'pet-policy-form',
      }
      if(this.isSMEProduct){
        this.$refs['sme-form'].lessSubmitForm()
        return
      }
      if (this.productId != 11) {
        this.$refs[productForm[this.productId]].getSaveSubmitForm()
        return
      }
      // 獲取表單組件數據
      if(this.isMotorTrade){
        delete this.subForm['insured-vehicle-form']
        if(this.isTPlate)
          delete this.subForm['drivers-base-info-form']
      }
      Object.keys(this.subForm).some(key => {
        this.subForm[key] = false
        this.$refs[key].getSaveSubmitForm(key)
      })
      // if (Object.values(this.subForm).some(item => item === false)) {
      //   return
      // }
      // todo
      let params = JSON.parse(JSON.stringify(this.formData))
      const filterDriverList = params.nm_drvr_list.filter(item => item.open)
      params.nm_drvr_list = filterDriverList
      params.no_of_nm_drvr = params.nm_drvr_list.length || 0
      params.order_id = this.orderId

      const documentFile =  this.$refs['document-form'].submitForm()
      if (!documentFile) return false

      Object.assign(params, documentFile)
      this.formParams = JSON.parse(JSON.stringify(params))
      if(this.type==2){
        if(this.isSMEProduct){
          this.network().handlerSMECreateRefer()
        }else{
          if(this.is_refer_order){
            this.handlerCreateReferOrder()
          }
          else  this.handlerCreateRefer()
        }
      }else {
        if(this.isSMEProduct){
          this.network().saveSMEKycLess({less_verify_save:1})
        }else
        {
          if(this.is_refer_order){
            this.network().saveReferCaseOrder()
          }else   this.network().saveLessOrder()
        }
      }
      return params

    },
    handlerConfirmChangeInfo(result) {
      if (result) {
        this.resultParams.upd_def_addr = 1
      }
      this.network().editQuoteResult()
    },
    async handlerSave() {
      if(this.isSMEProduct)
        await this.network().saveSMEKycLess()
      else{
        if(this.is_refer_order){
          await this.network().saveReferCaseOrder()
        }else await this.network().saveOrder()
      }
      if(this.isFina) {
        let {order_id,product_id,sme_versions} = this.$route.query||{}
        this.$router.push({
          path: '/quoting/referrer/send/payment',
          query: {
            order_id: order_id,
            product_id: product_id,
            sme_versions: sme_versions,
          }
        })
      }
      this.step = 0 // 重置
      this.less = false
      this.$emit('save')
    },
    async handlerLessSave(type) {
      this.step = 0
      this.less = true
      this.type = type
      this.getSave()
      this.$refs['use-personal-data'].handleSendData()
    },
    //todo
    cancelClick() {
      this.step = 0
      this.less = false
      this.$emit('cancel', false)
    },
    handlerBuyPolicy(index) {
      const data = this.allQuoteList[index].plan_info
      this.formParams = Object.assign(this.formParams, data)
      this.network().saveQuotation()
    },
    async referNext() {
      if(this.is_refer_order){
        await this.network().saveReferCaseOrder({
          less_verify_save: 1

        })
      }else {
        await this.network().saveOrder({
          less_verify_save: 1

        })
      }
      this.setQuoteInformationForm(this.formParams)
      // this.network().saveQuotation()
      this.$router.push({
        path: '/quoting/quote/refer/information',
        query: {
          order_id: this.$route.query.order_id,
          product_id: this.$route.query.product_id
        }
      })
    },
    // 記名司機同步
    handlerOpenDriver(data, list) {
      this.currentDriversData = data
    },
    getData(personalData){
      this.personalData = personalData
    },
    handler() {
      return {
        getFormDataResult: async () => {
          // 獲取表單組件數據
          if(this.isMotorTrade){
            delete this.subForm['insured-vehicle-form']
            if(this.isTPlate)
              delete this.subForm['drivers-base-info-form']
          }
          Object.keys(this.subForm).some(key => {
            this.subForm[key] = false
            this.$refs[key].submitForm(key)
          })
          if (Object.values(this.subForm).some(item => item === false)) {
            return
          }
          // todo
          let params = JSON.parse(JSON.stringify(this.formData))
          const filterDriverList = params.nm_drvr_list.filter(item => item.open)
          params.nm_drvr_list = filterDriverList
          params.no_of_nm_drvr = params.nm_drvr_list.length || 0
          params.order_id = this.orderId

          const documentFile = await this.$refs['document-form'].submitForm()
          if (!documentFile) return false

          Object.assign(params, documentFile)
          this.formParams = JSON.parse(JSON.stringify(params))
          return params
        }
      }
    },
    network() {
      return {
        editQuoteResult: async () => {
          this.$refs['use-personal-data'].handleSendData()
          this.resultParams.marketing_data = JSON.parse(JSON.stringify(this.personalData))
          const {data} = await editQuoteResult(this.resultParams)
          const {type, premium, coverage, other_quotes = []} = data
          if(this.isBack){
            this.step = 2
            this.allQuoteList = other_quotes.list
            this.quoteDetailData = other_quotes.detail
            this.setIsBack(false)
          }
          if(this.less)return this.step = 0
          switch (type) {
            case 1:
              this.step = 1
              this.premiumData = premium
              this.coverageData = coverage
              break
            case 2:
            case 3:
              this.step = 2
              this.allQuoteList = other_quotes.list
              this.quoteDetailData = other_quotes.detail
              break
          }
        },
        editSMEQuoteResult: async () => {
          this.$refs['use-personal-data'].handleSendData()
          this.resultParams.marketing_data = JSON.parse(JSON.stringify(this.personalData))
          const {data} = await editSMEQuoteResult(this.resultParams,this.classId)
          const {type, premium, coverage, other_quotes = []} = data
          if(this.isBack){
            this.step = 2
            this.setIsBack(false)
          }
          if(this.less)return this.step = 0
          let isRefer = premium.filter(item=>item.amt_n=='TBC')
          if(isRefer.length>0){
            this.setCustomerId(this.form.customer_id)
            this.setSMEQuoteInformationForm(this.resultParams)
            this.$router.push({
              path:`/quoting/quote/${this.smeType}/refer/information`,
              query: {
                order_id: this.$route.query.order_id,
                class_id: this.$route.query.product_id
              }
            })
            return
          }
          this.step = 1
          this.premiumData = premium
          this.coverageData = coverage
        },
        stepTypeIsBack: async () => {
          const {data} = await editQuoteResult(this.resultParams)
          const {type, premium, coverage, other_quotes = []} = data
          this.step = 2
          this.allQuoteList = other_quotes.list
          this.quoteDetailData = other_quotes.detail
        },
        saveOrder: async (params = {}) => {
          this.$refs['use-personal-data'].handleSendData()
          const {data} = await saveOrder({
            ...this.formParams,
            ...params,
            marketing_data: this.personalData
          })
        },
        saveReferCaseOrder: async (params = {}) => {
          this.$refs['use-personal-data'].handleSendData()
          const {data} = await saveReferCaseOrder({
            ...this.formParams,
            ...params,
            marketing_data: this.personalData
          })
        },
        saveLessOrder: async (params = {}) => {
          this.$refs['use-personal-data'].handleSendData()
          const {data} = await saveOrder({
            ...this.formParams,
            less_verify_save:1,
            ...params,
            marketing_data: this.personalData
          })
          this.step = 0 // 重置
          this.less = true
          this.$emit('save')
        },
        saveQuotation: async () => {
          const {data} = await saveQuotation(this.formParams)
          this.setQuoteInformationForm(this.formParams)
          this.step = 0
          this.$emit('save')
        },
        addReferral: async (params) => {
          let { data } = await addReferral(params)
          this.$router.push({
            path: '/tickets/detail',
            query: {
              ticket_id: data.ticket_id
            }
          })
        },
        saveSMEKycLess: async (params = {}) => {
          let {data} = await saveSMEKyc({
            ...this.formParams,
            order_id: this.orderId,
            ...params,
            marketing_data: this.personalData
          },this.classId)
          this.step = 0 // 重置
          this.less = true
          this.$emit('save')
        },
        handlerSMECreateRefer: async (params = {}) => {
          let {data} = await saveSMEKyc({
            ...this.formParams,
            order_id: this.orderId,
            ...params,
            less_verify_save:1,
            marketing_data: this.personalData
          },this.classId)
          this.setCustomerId(this.form.customer_id)
          this.setSMEQuoteInformationForm(this.formParams)
          this.$router.push({
            path:`/quoting/quote/${this.smeType}/refer/information`,
            query: {
              order_id: this.$route.query.order_id,
              class_id: this.$route.query.product_id
            }
          })
        },
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-container {
  position: relative;
  color: #616266;
  .nargin-right{
    margin-right: 10px;
  }
  .abs-top-right {
    & > div {
      display: inline-block;
      margin-left: 10px;
    }
  }

  .title {
    display: block;
    padding-bottom: 15px;
    color: #616266;
    font-size: 20px;
    font-weight: 500;
  }

  h1 {
    padding-bottom: 10px;
    font-size: 24px;
  }

  p {
    padding-bottom: 10px;
    font-size: 16px;
  }

  .form-block {
    margin-bottom: 15px;

    & > span:first-child {
      display: block;
      padding-bottom: 5px;
      font-weight: 500;
      font-size: 14px;
    }
  }

  .edit-box {
    margin-bottom: 15px;
    color: #616266;

    .label {
      display: block;
      margin-bottom: 5px;
      font-size: 14px;
      font-weight: bold;
      color: #616266;
    }

    .driver-doc {
      .title {
        font-size: 20px;
        font-weight: bold;
      }
    }

    .drivers-container {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .card {
        position: relative;
        margin-bottom: 15px;
        width: calc(50% - 10px);

        .driver-switch {
          position: absolute;
          top: 15px;
          right: 15px;
        }

        .mask {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          top: 50px;
          z-index: 2;
          background: rgba(255, 255, 255, 0.7);
        }
      }

      // .form-disabled {
      //   .form-block {
      //     & > span:first-child {
      //     }
      //   }
    }
  }

  .form-row {
    display: flex;
    margin-bottom: 10px;

    .form-col {
      flex: 1;

      &:first-child {
        margin-right: 10px;
      }

      &:last-child {
        margin-left: 10px;
      }

      // .label {
      //   display: inline-block;
      //   padding-bottom: 5px;
      //   font-size: 14px;
      //   font-weight: 500;
      // }
    }
  }

  .file-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    padding: 0 15px;
    height: 65px;
    border: 1px solid #dddfe7;
    border-radius: 4px;
    background: #fcfcfc;

    .file-info {
      color: #616266;
      font-size: 16px;
    }
  }
}

.confirm-container {
  margin-top: 10px;
  justify-content: space-between;

  h1 {
    padding-bottom: 15px;
  }

  & > div {
    width: calc(50% - 10px);
  }

  .table {
    .tr {
      & > span {
        flex: 1;
        padding-right: 5px;

        span {
          display: inline-block;
          padding-right: 10px;
        }
      }
    }
  }
}

.plan-container {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  padding: 15px;
  border-radius: 4px;
  background: white;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  .left {
    width: 130px;
    text-align: center;

    .logo {
      display: block;
      width: 120px;
      height: 64px;
    }
  }

  .right {
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    margin: -15px -15px -15px 0;
    padding-left: 10px;
    width: 140px;
    background: #f4f4f5;

    .amount {
      display: block;
      font-size: 24px;
      font-weight: bold;
      color: #409eff;
    }

    .unit {
      color: #616266;
      font-size: 12px;
    }

    .el-button {
      position: absolute;
      bottom: 15px;
      left: 15px;
    }
  }

  .middle {
    flex: 1;
    position: relative;
    padding-right: 10px;

    .abs-top-right {
      right: 15px;
    }

    .title {
      font-size: 20px;
      color: #616266;
      font-weight: bold;
    }

    .flex {
      justify-content: space-between;

      .table {
        width: calc(50% - 7px);

        .table-title {
          font-size: 12px;
          font-weight: bold;
          color: #909399;
        }

        &:first-child {
          .tr {
            span:first-child {
              width: 115px;
            }
          }
        }

        &:last-child {
          .tr {
            span:first-child {
              width: 130px;
            }
          }
        }
      }
    }
  }
}

.strip {
  .tr {
    &:nth-child(2n) {
      background: transparent !important;
    }

    &:nth-child(2n-1) {
      background: rgba(0, 0, 0, 0.02);
    }
  }
}

.table {
  margin: 5px 0 10px 0;

  .th {
    color: #909399 !important;
  }

  .tr {
    display: flex;
    padding: 10px;
    width: 100%;
    border-bottom: 1px solid #dddfe7;
    font-size: 12px;
    color: #606266;

    &.top-border {
      border-top: 1px solid #dddfe7;
    }

    &:nth-child(2n) {
      background: rgba(0, 0, 0, 0.02);
    }

    & > span:first-child {
      font-weight: bold;
    }

    & > span:last-child {
      padding-left: 10px;
    }
  }

}
.margin-top-ten{
  margin-top: 10px;
}
.extra_checkbox{
  ::v-deep .el-checkbox-group{
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
